import { TicketshopPage } from "components/TicketshopPage";
import React from "react";

export default function MaadCityPage() {
  return (
    <TicketshopPage
      scriptString={`<script src="https://web-cdn.fixr.co/scripts/fixr-shop-widget.v1.min.js?salesChannel=whitelabel-website" data-name-filter="maad city" data-fixr-shop-id="be31447a-9d7b-4108-bde6-c9cb9a5287e1" data-fixr-theme="light"></script>`}
      imageSrc="/logo/maad-city-logo.png"
      backgroundSrc="/hero/maad-city-hero.jpg"
      imageMaxWidth="322px"
      title="MAAD CITY"
      description={
        <>
          <p>
            We bring the maaddest vibes and the baaddest tunes to Belgrave Music
            Hall every Tuesday. Expect sick Hip Hop, RNB and Afrobeats in the
            main room, head downtown for a mash up of garage, bass, DnB and
            house or climb to the 3rd floor & experience our chill out rooftop
            with cityscape views. Dough Boy pizza slices will be on sale
            throughout the night. The 3 floors of Belgrave are about to get
            flipped on their head!
          </p>
          <p>
            Our lights to the City are now on, be sure to join the population!
          </p>
        </>
      }
    />
  );
}
